import {
    Grid,
    Box,
    Checkbox,
    FormControlLabel,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    FormControl
} from "@mui/material";
import { useState, Fragment } from 'react';
import Swal from "sweetalert2";
import DialogText from "./DialogText";
import ClearIcon from "@mui/icons-material/Clear";
import RegisterConfirm2 from "./RegisterConfirm2";
import { useHistory } from 'react-router-dom';

function RegisterConfirm(props) {
    // const [openConfirm2, setOpenConfirm2] = useState(false);

    // const clickOpenConfirm2 = () => {
    //     setOpenConfirm2(true);
    // };

    // const clickCloseConfirm2 = () => {
    //     setOpenConfirm2(false);
    // };

    const history = useHistory();
    // const {goNextPage, goPreviousPage} = props;

    return (
        <Box
            container
            height='100%'
            direction='column'
            justifyContent='center'
            overflow='hidden'>
            <Box
                sx={{
                    overflow: 'scroll',
                    padding: '0 20px'
                }}>
                {/* <Box
                    sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        marginTop: '20px'
                    }}>
                서비스 이용약관에 대한 동의(필수)
                </Box> */}
                <DialogText></DialogText>
                {/* <Box sx={{ height: '120px' }}></Box> */}
            </Box>
            {/* <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    padding: '15px 0 20px',
                    background: 'white'
                }}>
                <Box
                    sx={{
                        marginBottom: '5px'
                    }}>
                    서비스 이용약관에 동의합니다.
                </Box>
                <Button variant="contained"
                    sx={{ width: "40%", margin: "5px", background: "#0092a2" }}
                    onClick={goNextPage}>
                    예
                </Button>
                <Button variant="outlined" sx={{ width: "40%", margin: "5px", border: "1px solid gray", color: "gray" }} onClick={goPreviousPage}>아니오</Button>
            </Box> */}
        </Box>
    )
}
export default RegisterConfirm;